import actions from './actions'
import { DOWNLOAD_STATUS } from './constants'

const initialState = {
  status: DOWNLOAD_STATUS.NOOP,
  error: null,
  isModalOpen: false,
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case actions.download.INIT_TYPE: {
      return {
        ...state,
        error: null,
        status: DOWNLOAD_STATUS.DOWNLOADING,
      }
    }
    case actions.download.SUCCESS_TYPE: {
      return {
        ...state,
        status: DOWNLOAD_STATUS.DOWNLOADED,
      }
    }
    case actions.download.FAILURE_TYPE: {
      return {
        ...state,
        error: payload.error,
        status: DOWNLOAD_STATUS.DOWNLOAD_FAILED,
      }
    }
    default:
      return state
  }
}

export default reducer
